import { Temporal } from 'temporal-polyfill';
import { IMetricsDataModel } from '../../data-models/metrics.data-model';
import { CalculatedMetricsDataModel } from '../../pages/PortfolioOverview/components/OverviewTable/MetricsCalculator';

export function calculateMetricsOnFilteredData(
  metrics: CalculatedMetricsDataModel[],
  _filteredData: IMetricsDataModel[],
  _asOfDate: Temporal.PlainDate
): { metrics: CalculatedMetricsDataModel[]; filteredMetrics: CalculatedMetricsDataModel[] } {
  return { metrics, filteredMetrics: _filteredData as CalculatedMetricsDataModel[] };
}
